<template>
  <div>
    <trumbowyg class="form-control"
      v-model="internalValue"
      @input="$emit('input', arguments[0])"
      :name="name"
      :config="config"
      ></trumbowyg>
  </div>
</template>

<script>
import { set } from 'lodash'

export default {
  props: {
    value: {
      type: String,
      required: true
    },

    name: {
      type: String,
      default: 'name'
    },

    uploadUrl: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      internalValue: '',

      config: {
        svgPath: false,
        hideButtonTexts: true,
        btnsDef: {
          // Customizables dropdowns
          image: {
            dropdown: ['insertImage', 'upload'],
            ico: 'insertImage'
          }
        },
        btns: [
          // ['viewHTML'],
          ['undo', 'redo'],
          ['formatting'],
          ['strong', 'em', 'del', 'underline'],
          ['link'],
          ['image'],
          ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
          ['unorderedList', 'orderedList'],
          ['foreColor', 'backColor'],
          ['preformatted'],
          ['horizontalRule'],
          ['fullscreen']
        ],
        plugins: {
          resizimg: {
            minSize: 64,
            step: 16
          },
          upload: {
            serverPath: '',
            fileFieldName: 'file',
            statusPropertyName: 'id',
            urlPropertyName: 'url',
            headers: {
              accepts: 'application/json',
              'contentType': 'multipart/form-data;'
            }
          }
        }
      }
    }
  },

  watch: {
    '$props': {
      handler (props) {
        set(this.config, 'plugins.upload.serverPath', props.uploadUrl || '')
      },
      deep: true
    },

    value (next, old) {
      if (next !== old && next !== this.internalValue) {
        this.internalValue = next
      }
    }
  },

  methods: {
    //
  },

  created () {
    const self = this

    self.internalValue = self.value
    set(self.config, 'plugins.upload.serverPath', self.uploadUrl)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ui/TrumbowygTextArea.vue